$(function() {
    const hover = {
        init() {
            hover.create();
        },
        create() {
            const eleHoverGroup = $('[data-ele-hover-group]');
            if(eleHoverGroup.length == 0) return;

            eleHoverGroup.each(function(index, el) {
                const self = $(this);
                

                self.on('mouseleave', function(event) {
                    self.removeClass('on-focus');
                    self.find('[data-ele-hover]').removeClass('hover');
                });
            });

            $('body').on('mouseenter', '[data-ele-hover]', function(event) {
                $(this).parents('[data-ele-hover-group]').addClass('on-focus');
                if($(this).has('[data-wrap]')) {
                    $(this).addClass('hover').parent().siblings().find('[data-ele-hover]').removeClass('hover');
                } else {
                    $(this).addClass('hover').siblings().removeClass('hover');
                }
            });
        }
    };

    hover.init();
});